import { tv, cn } from '@costar-ui/cosmos';
import React__default from 'react';
import { Headline } from '../headline/headline.esm.js';

var ArticleTitleVariants = /*#__PURE__*/function (ArticleTitleVariants) {
  ArticleTitleVariants["ArticleTitleMedium"] = "articleTitleMedium";
  ArticleTitleVariants["ArticleTitleXLarge"] = "articleTitleXLarge";
  return ArticleTitleVariants;
}({});
var articleTitleVariants = tv({
  base: 'font-bold',
  //default styles
  variants: {
    articleTitleVariant: {
      defaultVariant: 'text-p-16',
      //16px/24px
      articleTitleMedium: 'text-p-16/5 lg:text-p-18/6',
      //16px/20px 18px/24px
      articleTitleXLarge: 'text-p-24' //24px/32px
    }
  },
  defaultVariants: {
    articleTitleVariant: 'defaultVariant'
  }
});
/**
 * @description
 * **An atomic component that accepts an element as children and applies styles
 * based on the chosen variant to function as a boldened title of an article**
 *
 * @property {React.ReactNode} **children**: Nested element between ArticleTitle
 * tags provided by consumer to serve as the title
 * @property {string} **[className]**: optional prop to add additional tailwind classNames
 * @property {ArticleTitleVariant | null} **[articleTitleVariant]**: optional prop to choose one of the following variants
 * >-  FeaturedSubArticle _[default]_
 * >-  FeaturedSubArticleWithImage
 * >-  ArticleTitleXLarge
 *
 * @example
 * <ArticleTitle articleTitleVariant={ArticleTitleVariants.ArticleTitleXLarge}>
 *    <Link href={articleLinkUrl}>{articleTitle}</Link>
 * </ArticleTitle>
 *
 * <ArticleTitle>
 *    <a href={"/news/articles/2134"}>{articleTitle}</a>
 * </ArticleTitle>
 */
var ArticleTitle = function ArticleTitle(_ref) {
  var children = _ref.children,
    className = _ref.className,
    articleTitleVariant = _ref.articleTitleVariant,
    _ref$headlineTag = _ref.headlineTag,
    headlineTag = _ref$headlineTag === void 0 ? 'h2' : _ref$headlineTag;
  return /*#__PURE__*/React__default.createElement(Headline, {
    as: headlineTag,
    className: cn("hover:text-action-primary-hover" /* Review Usage */, articleTitleVariants({
      articleTitleVariant: articleTitleVariant
    }), className)
  }, /*#__PURE__*/React__default.createElement("span", null, children));
};

export { ArticleTitle, ArticleTitleVariants };
//# sourceMappingURL=article-title.esm.js.map
